import React, { useMemo, useCallback } from 'react'
import { IconButton, Select, Bleed } from '@fs/zion-ui'
import { ArrowCaret } from '@fs/zion-icon'

import transl from '../../ChangeHistory.transl'
import styles from '../../ChangeHistory.styles'
import getFormattedDate, { dateFormats } from '../../../../../../../shared/utils/dateFormatHelper'

export default function HistoryNavigator({ history = [], onChange, currentDateTime }) {
  const options = useMemo(() => {
    let result = {} // Use object to avoid duplicates
    if (history) {
      history.forEach((item) => {
        if (item?.date?.fromTimestamp == null) return

        const dateFormattedFullWithTime = getFormattedDate(
          item.date.fromTimestamp,
          item.date.toTimestamp,
          dateFormats.formattedFullWithTime
        )
        const date =
          getFormattedDate(
            item?.date?.fromTimestamp,
            item?.date?.toTimestamp,
            dateFormats.formattedCompactWithHourMinute
          ) || dateFormattedFullWithTime
        result = {
          ...result,
          [dateFormattedFullWithTime]: { value: dateFormattedFullWithTime, label: date, key: item.date.fromTimestamp },
        }
      })
    }
    return Object.values(result)
  }, [history])

  const forwardOption = useMemo(() => {
    const index = options.findIndex((item) => item.value === currentDateTime)
    if (index > 0) {
      return options[index - 1]?.value
    }
    return null
  }, [options, currentDateTime])

  const backwardOption = useMemo(() => {
    const index = options.findIndex((item) => item.value === currentDateTime)
    if (index > -1 && index < options.length - 1) {
      return options[index + 1]?.value
    }
    return null
  }, [options, currentDateTime])

  const handleChange = useCallback(
    (directionOrSelected) => {
      if (currentDateTime && typeof onChange === 'function') {
        onChange(() => {
          if (directionOrSelected === 'backward') return backwardOption
          if (directionOrSelected === 'forward') return forwardOption
          return directionOrSelected
        })
      }
    },
    [currentDateTime, forwardOption, backwardOption, onChange]
  )

  return (
    <Bleed>
      <div css={styles.navWrapper}>
        <div css={styles.navButton}>
          <IconButton
            data-testid="back-nav-button"
            disabled={!backwardOption}
            Icon={ArrowCaret}
            iconDirection="backward"
            onClick={() => handleChange('backward')}
            description={transl.previous()}
          />
        </div>
        <Select
          label={transl.dateAndTimeSelect()}
          options={options}
          value={currentDateTime}
          hidePlaceholder
          onChange={(e) => handleChange(e.target.value)}
        />
        <div css={styles.navButton}>
          <IconButton
            data-testid="forward-nav-button"
            disabled={!forwardOption}
            Icon={ArrowCaret}
            iconDirection="forward"
            onClick={() => handleChange('forward')}
            description={transl.next()}
          />
        </div>
      </div>
    </Bleed>
  )
}
